import * as React from 'react';
import { CheckmarkUniversal } from '@duxton-web/icons';
import { Button, Form, Space } from 'antd';

import OutsideClickHandler from '../../common/OutsideClickHandler';
import AppVersionFieldset from './AppVersionFieldset';
import { isValidAppVersion } from './appVersionUtils';

const InputGroup = Space.Compact;

interface InlineEditorProps {
  initialValue?: string;
  onSubmit: (value: string) => void;
  onCancel: () => void;
}

interface InlineEditorState {
  appVersion: string;
  hasError: boolean;
}

export class AppVersionInlineEditor extends React.Component<
  InlineEditorProps,
  InlineEditorState
> {
  containerElement: HTMLSpanElement;

  constructor(props: InlineEditorProps) {
    super(props);
    this.state = {
      appVersion: props.initialValue || '',
      hasError: false,
    };
  }

  handleAppVersionChange = (appVersion) => {
    this.setState({ appVersion, hasError: false });
  };

  handleSubmit = (event: { preventDefault: () => void }) => {
    event?.preventDefault?.();

    const { onSubmit } = this.props;
    const { appVersion } = this.state;
    const hasError = !isValidAppVersion(appVersion);

    if (hasError) {
      this.setState({
        hasError,
      });
    } else {
      onSubmit(appVersion);
    }
  };

  setContainerElement = (element: HTMLSpanElement) => {
    this.containerElement = element;
  };

  getPopupContainer = () => {
    return this.containerElement;
  };

  render() {
    const { onCancel } = this.props;
    const { appVersion, hasError } = this.state;
    return (
      <span
        className={hasError ? 'has-error' : ''}
        style={{ display: 'inline-block', marginRight: '8px' }}
      >
        <OutsideClickHandler onClickOutside={onCancel}>
          <span ref={this.setContainerElement}>
            <Form onFinish={this.handleSubmit}>
              <InputGroup>
                <AppVersionFieldset
                  value={appVersion}
                  onChange={this.handleAppVersionChange}
                  getPopupContainer={this.getPopupContainer}
                />
                <Button size="small" htmlType="submit">
                  <CheckmarkUniversal />
                </Button>
              </InputGroup>
            </Form>
          </span>
        </OutsideClickHandler>
      </span>
    );
  }
}

export default AppVersionInlineEditor;
